/* 1119 - phone carousel and the preview strip under it.

   The strip is a READ-ONLY preview: it shows the shots for the selected colour
   and marks the one on screen. Tapping is deliberately off.

   Why: the theme's slideshow caches its slide list when it starts and then owns
   the scroll position. Once the colour filter hides some slides, its "slide 3"
   is not the third one the eye sees - taps landed on the wrong shot, the
   highlight sat on the wrong box, and the last one could not be reached.
   Removing slides, moving them, and scrolling the track by hand were all tried;
   the component either kept its stale references or pulled the scroll straight
   back. So the strip no longer tries to steer it. Swiping does, and swiping was
   the part that always worked. */
(function () {
  if (window.__gtapCarousel) return;
  window.__gtapCarousel = true;

  var track, strip;

  function isFlat(el) {
    var img = el.querySelector('img');
    if (!img) return null;
    var w = parseInt(img.getAttribute('width'), 10) || img.naturalWidth;
    var h = parseInt(img.getAttribute('height'), 10) || img.naturalHeight;
    if (!w || !h) return null;
    return w === h;
  }

  function stamp(box) {
    var kids = box.children;
    for (var i = 0; i < kids.length; i++) {
      if (!kids[i].hasAttribute('data-gtap-i')) kids[i].setAttribute('data-gtap-i', i);
    }
  }

  function ord(el) { return parseInt(el.style.order, 10) || 0; }

  /* back, lifestyle, front, lifestyle - the supplier exports front then back,
     so the flats are reversed to lead with the print. CSS order only: the nodes
     are never moved, which is what kept the theme's own bookkeeping intact. */
  function order(box) {
    var flats = [], lifes = [], kids = box.children, i;
    for (i = 0; i < kids.length; i++) {
      kids[i].style.order = '';
      if (kids[i].hasAttribute('data-gtap-hide')) continue;
      var flat = isFlat(kids[i]);
      if (flat === null) return false;
      (flat ? flats : lifes).push(kids[i]);
    }
    if (!flats.length && !lifes.length) return false;
    flats.reverse();
    var n = Math.max(flats.length, lifes.length);
    for (var k = 0; k < n; k++) {
      if (flats[k]) flats[k].style.order = k * 2 + 1;
      if (lifes[k]) lifes[k].style.order = k * 2 + 2;
    }
    return true;
  }

  /* the slides the shopper can actually see, in the order they see them */
  function shown() {
    var out = [], kids = track.children, i;
    for (i = 0; i < kids.length; i++) {
      if (!kids[i].hasAttribute('data-gtap-hide')) out.push(kids[i]);
    }
    out.sort(function (a, b) { return ord(a) - ord(b); });
    return out;
  }

  /* every thumbnail copies the state of the slide it was rendered next to */
  function mirror() {
    if (!strip) return;
    var by = {}, btns = strip.children, i;
    for (i = 0; i < btns.length; i++) by[btns[i].getAttribute('data-gtap-i')] = btns[i];
    var slides = track.children;
    for (i = 0; i < slides.length; i++) {
      var b = by[slides[i].getAttribute('data-gtap-i')];
      if (!b) continue;
      var hide = slides[i].hasAttribute('data-gtap-hide');
      if (b.hasAttribute('data-gtap-hide') !== hide) b.toggleAttribute('data-gtap-hide', hide);
      var o = slides[i].style.order || '';
      if (b.style.order !== o) b.style.order = o;
    }
  }

  function thumbFor(slide) {
    if (!strip) return null;
    var btns = strip.children;
    for (var i = 0; i < btns.length; i++) {
      if (btns[i].getAttribute('data-gtap-i') === slide.getAttribute('data-gtap-i')) return btns[i];
    }
    return null;
  }

  /* Read from the scroll position, which is the one thing that is always true.
     The theme's own aria-selected points into its cached list and is wrong once
     the filter runs, so the highlight keys off data-gtap-on in the stylesheet. */
  function paintOn() {
    if (!strip || !track.clientWidth) return;
    var list = shown();
    if (!list.length) return;
    var i = Math.round(track.scrollLeft / track.clientWidth);
    if (i < 0) i = 0;
    if (i > list.length - 1) i = list.length - 1;
    for (var k = 0; k < list.length; k++) {
      var b = thumbFor(list[k]);
      if (!b) continue;
      var on = k === i;
      if (b.hasAttribute('data-gtap-on') !== on) b.toggleAttribute('data-gtap-on', on);
    }
  }

  function paint() {
    var t = document.querySelector('media-gallery slideshow-slides');
    if (!t) return;
    strip = document.querySelector('media-gallery .slideshow-controls__thumbnails');
    if (t !== track) {
      track = t;
      track.addEventListener('scroll', paintOn, { passive: true });
    }
    stamp(track);
    if (strip) stamp(strip);
    if (!order(track)) return;
    mirror();
    paintOn();
  }

  function start() {
    paint();
    if (!window.MutationObserver) return;
    var t = null;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(paint, 90);
    }).observe(document.documentElement, {
      subtree: true, childList: true, attributes: true, attributeFilter: ['data-gtap-hide']
    });
    window.addEventListener('load', paint);
    setTimeout(paint, 700);
    setTimeout(paint, 1700);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
